import { Authenticated, Unauthenticated } from "convex/react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  return (
    <>
      <Unauthenticated>
        <ProtectedRouteRedirect />
      </Unauthenticated>
      <Authenticated>
        {children}
      </Authenticated>
    </>
  );
}

function ProtectedRouteRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
    </div>
  );
}

